import { render, staticRenderFns } from "./QbExamCourseSemester.vue?vue&type=template&id=0ab00031&"
import script from "./QbExamCourseSemester.vue?vue&type=script&lang=js&"
export * from "./QbExamCourseSemester.vue?vue&type=script&lang=js&"
import style0 from "./QbExamCourseSemester.vue?vue&type=style&index=0&id=0ab00031&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports